import { Component, OnInit } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';

import { TipsService } from './../../tips/tips.service';

@Component({
  selector: 'app-tips-block',
  templateUrl: './tips-block.component.html',
  styleUrls: ['./tips-block.component.less']
})
export class TipsBlockComponent implements OnInit {

	public data: object = {};
	private inscription: Subscription;

	constructor(private _service: TipsService) { }

	ngOnInit() {
		this.inscription = this._service.listAllLimit(2)
		.subscribe(
			response => {
				this.data['itens'] = response;
			},
			error => {
				console.error ( error );
			}
		);
	}

}



// WEBPACK FOOTER //
// /Users/henriquezanini/Sites/Cães e Gatos/site/src/app/shared/tips-block/tips-block.component.ts